import { getUser } from '../utils/func';

export function signalInApp(kind, details = {}) {
  const userId = getUser()?.id;
  if (!userId) return;
  window.dispatchEvent(new CustomEvent('wiw:in-app-signal', { detail: { ...details, kind, userId, at: Date.now() } }));
}

export function inAppPreferencesChanged(preferences) {
  window.dispatchEvent(new CustomEvent('wiw:in-app-preferences', { detail: { userId: getUser()?.id, preferences } }));
}
